import { SearchFieldOption } from '@view/shared/molecules/search-controls/search-controls.component';
import { SearchField } from '../../../domain/types/search-field.type';

const ICON_DOCUMENTO = 'icon-documento';
const ICON_CARNET = 'icon-carnet';
const ICON_FICHA_NOMBRE = 'icon-ficha-nombre';

export const INGESTED_ORDER_SEARCH_OPTIONS: SearchFieldOption[] = [
  {
    label: 'Código examen',
    value: SearchField.EXAM_CODE,
    inputType: 'text',
    placeholder: 'Ingrese código del examen',
    icon: ICON_DOCUMENTO
  },
  {
    label: 'Nombre del examen',
    value: SearchField.EXAM_NAME,
    inputType: 'text',
    placeholder: 'Ingrese nombre del examen',
    icon: ICON_DOCUMENTO
  },
  {
    label: 'Fecha de ingreso',
    value: SearchField.ADMISSION_DATE,
    inputType: 'date',
    placeholder: 'Seleccione fecha',
    icon: 'icon-calendario'
  },
  {
    label: 'Sede de ingreso',
    value: SearchField.ADMISSION_SITE,
    inputType: 'text',
    placeholder: 'Ingrese sede',
    icon: ICON_DOCUMENTO
  },
  {
    label: 'Regional',
    value: SearchField.REGIONAL,
    inputType: 'text',
    placeholder: 'Ingrese regional',
    icon: ICON_DOCUMENTO
  },
  {
    label: 'Tipo ID',
    value: SearchField.ID_TYPE,
    inputType: 'text',
    placeholder: 'Ingrese tipo de identificación',
    icon: ICON_CARNET
  },
  {
    label: 'Número de ID del paciente',
    value: SearchField.PATIENT_ID,
    inputType: 'text',
    placeholder: 'Ingrese número de identificación',
    icon: ICON_CARNET
  },
  {
    label: 'Nombres paciente',
    value: SearchField.PATIENT_FIRST_NAME,
    inputType: 'text',
    placeholder: 'Ingrese nombres del paciente',
    icon: ICON_DOCUMENTO
  },
  {
    label: 'Apellidos',
    value: SearchField.PATIENT_LAST_NAME,
    inputType: 'text',
    placeholder: 'Ingrese apellidos del paciente',
    icon: ICON_DOCUMENTO
  }
];

export const RECEIVED_ORDER_SEARCH_OPTIONS: SearchFieldOption[] = [
  {
    label: 'Código de muestra',
    value: SearchField.CASE_NUMBER,
    inputType: 'text',
    placeholder: 'Ingrese código de muestra',
    icon: 'icon-recibo'
  },
  {
    label: 'ID Paciente',
    value: SearchField.PATIENT_ID,
    inputType: 'text',
    placeholder: 'Ingrese número de identificación',
    icon: ICON_CARNET
  },
  {
    label: 'Nombre',
    value: SearchField.PATIENT_FIRST_NAME,
    inputType: 'text',
    placeholder: 'Ingrese nombre del paciente',
    icon: ICON_FICHA_NOMBRE
  },
  {
    label: 'Apellido',
    value: SearchField.PATIENT_LAST_NAME,
    inputType: 'text',
    placeholder: 'Ingrese apellido del paciente',
    icon: ICON_FICHA_NOMBRE
  }
];

export const OBSERVATION_SEARCH_OPTIONS: SearchFieldOption[] = [
  {
    label: 'Código de muestra',
    value: SearchField.CASE_NUMBER,
    inputType: 'text',
    placeholder: 'Ingrese código de muestra',
    icon: 'icon-recibo'
  },
  {
    label: 'Código del examen',
    value: SearchField.EXAM_CODE,
    inputType: 'text',
    placeholder: 'Ingrese código del examen',
    icon: ICON_DOCUMENTO
  },
  {
    label: 'Número de documento',
    value: SearchField.PATIENT_ID,
    inputType: 'text',
    placeholder: 'Ingrese número de documento',
    icon: ICON_CARNET
  }
];
